import { QueryClient } from '@tanstack/react-query';

/**
 * Cliente de TanStack Query. Orquesta el estado de SERVIDOR del seam dual
 * RTDB+REST (rider-core `dual`). Las suscripciones RTDB en vivo (flota,
 * reservas) se integrarán como streams en F2.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
